.
<template>
  <div class="wifi">
    <div class="line" style="--i: 0" />
    <div class="line" style="--i: 1" />
    <div class="line" style="--i: 2" />
    <div class="dot" />
  </div>
</template>
<script setup lang="ts">
defineOptions({
  name: 'VWifi',
})
</script>
